<template>
  <div style="width:100%;float:left;">
    <div style="width:100%;float:left;" v-if="!loading">
      <!-- <CRow>
        <CCol sm="12">
          <pdf-order @pdf-sent="pdfSent" :order_id="order_id"></pdf-order>
        </CCol>
      </CRow> -->
      <CRow>
        <!-- <CCol sm="12" md="8">
          <order-display :order_id="order_id"></order-display>
        </CCol> -->
        <CCol sm="12" md="8">
          <pdf-order @pdf-sent="pdfSent" :order_id="order_id"></pdf-order>
        </CCol>
        <CCol sm="12" md="4">
          <order-actions @got-order="setOrder" :order_id="order_id" :form="form"></order-actions>
          <chat :order_id="order_id"></chat>
          <timeline :order_id="order_id"></timeline>
          <people-involved :order_id="order_id"></people-involved>
        </CCol>
      </CRow>
    </div>
    <small-loader v-else></small-loader>
  </div>
</template>
<script>
import OrderDisplay from './order_display'
import OrderActions from './../components/order_actions'
import Chat from './../components/chat'
import Timeline from './../components/timeline'
import PdfOrder from './../components/pdf_order'
import PeopleInvolved from './../components/people_involved'
var methods = {}

methods.reorder = function () {
  this.$router.push('/create_order/' + this.order_id)
}

methods.setOrder = function (form) {
  console.log('set order')
  console.log(form)
  this.form = form
}

methods.pdfSent = function () {
  this.$emit('pdf-sent')
}

export default {
    // ===Component name
    name: "OrderWrapper",
    // ===Props passed to component
    props: ['order_id'],
    // ===Components used by this component
    components: {
      OrderDisplay,
      Chat,
      Timeline,
      PeopleInvolved,
      PdfOrder,
      OrderActions
    },
    // ====component Data properties
    data(){
        return{
          loading: false,
          form: null
        }
    },
    watch: {
      'order_id': function (newVal, oldVal) {
        if (newVal) {
          this.loading = true
          var that = this
          setTimeout(function () {
            that.loading = false
          },500)
        }
      }
    },
    // ===Code to be executed when Component is mounted
    mounted() {

    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
